export const PaypalConfig = {
  pyusdShortName: 'paypal_pyusd',
  redeemPyusdShortName: 'paypal_pyusd_payout',
  btnChangingTimeout: 5000,
  paypalBtnShowingTimeout: 5000
}
